module.exports = __webpack_public_path__ + "img/01-thumb.d8540a07.jpg";